export const viewTitle = "Список ЭАД";
export const viewUniqKey = "ead";
export const newViewUniqKey = "eadNewView";
